// extracted by mini-css-extract-plugin
export var columnList = "_dm-0";